export default {
    dependencies: ['$element', 'trackingservice'],
    callable(ele, trackingservice) {
        ele.addEventListener('keydown', event => {
            if (
                event.target.matches("[type='checkbox']") &&
                event.which === 13 /* Enter */
            ) {
                event.target.click();
                event.preventDefault();
                event.stopPropagation();
            }
        });

        ele.addEventListener('change', trackFilterSelection);

        function trackFilterSelection(event) {
            const checkbox = event.target;
            if (checkbox.checked) {
                trackingservice.trackEventObject({
                    analyticsName: `navigation.filter-by-${checkbox.name.replace(
                        /_/g,
                        ''
                    )}.click`,
                    stringValue: `${checkbox.name}:${checkbox.value}`,
                });
            }
        }
    },
};



// WEBPACK FOOTER //
// ./controllers/multiSelectWidget.js